import { useSuspenseQuery } from '@tanstack/react-query'

import { regionsQuery } from './regions'

export const useRegionList = () => {
  const { data: state } = useSuspenseQuery(regionsQuery())
  return state
}
